import { GET_COMPANY_NEWS, GET_HOME_NEWS, SET_CURRENT_NEWS_TYPE_LABEL } from "./types";

export default {
  [SET_CURRENT_NEWS_TYPE_LABEL]: (state, label) => {
    state.currentType = label;
  },

  [GET_COMPANY_NEWS]: (state, newsList) => {
    state.company = newsList;
  },

  [GET_HOME_NEWS]: (state, newsList) => {
    state.home = newsList;
  }
};
